import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import carImg from 'images/tmp_car_image.png'
import styles from './index.module.css'

const CarMy = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			{/* 내 차 정보 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-align_center">
						<h3>내 차 정보</h3>
						<span className={`${styles["title-guide"]} ml_10`}>2019.01.01 기준</span>
					</div>

					{/* 차량 이미지 있을 때 */}
					<div className="img-box mt_40" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
						<img src={carImg} alt="" />
					</div>
					{/* 차량 이미지 없을 때 */}
					<div className="center-cont no-data-box py_40">
						<i className="icon icon_no_data" />
						<p className="mt_20">최근 조회한 차량이 없어요.</p>
					</div>

					<span className="license-plate mt_35">245 무 1245</span>
					<div className="car-info mt_20">
						<div>
							<span>테슬라</span>
							<span>테슬라 모델X</span>
						</div>
						<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
					</div>
					<div className="car-price mt_15"><strong className="text-blue">13,800</strong> 만원</div>
					<hr className="mt_20 my_30" />
					<div className="sub-guide">출시가 대비 <strong className="text-red">-13.7%</strong></div>

					{/* 그래프 영역 */}
					<div className="mt_20" style={{ height: "17.5rem", background: "#f5f5f5", padding: "0 2rem" }}></div>
					<div className="flex-justify_end mt_10" style={{ color: "#666" }}>*단위(만km)</div>

					{/* 그래프 데이터 없을 때 */}
					<div className="center-cont no-data-box py_40">
						<i className="icon icon_no_data" />
						<p className="mt_20">데이터가 없어요.</p>
					</div>

					<div className="swiper-guide mt_20">
						<i className="icon icon_swiper_arrow mr_10" />
						<span>그래프를 좌우로 스와이프 해보세요.</span>
					</div>
				</div>
			</div>

			{/* 기본정보 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>기본정보</h3>
						<i className="icon icon_arrow_sm right icon_arrow_md" />
					</div>
					<ul className="list-item mt_40">
						<li>
							<span>연식</span>
							<span>2022년식</span>
						</li>
						<li>
							<span>배기량</span>
							<span>18,000cc</span>
						</li>
						<li>
							<span>연비</span>
							<span>17.5km/l</span>
						</li>
						<li>
							<span>연료</span>
							<span>가솔린</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 옵션정보 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>옵션정보</h3>
						<i className="icon icon_arrow_sm right icon_arrow_md" />
					</div>
					<ul className="car-option mt_30">
						<li>
							<i className="icon icon_car_option icon_car_option_navi" />
							<span>내비게이션</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_key active" />
							<span>스마트키</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_loof active" />
							<span>선루프</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_pass" />
							<span>하이패스</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_camera" />
							<span>후방카메라</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_view active" />
							<span>어라운드뷰</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 수리정비내역 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>수리정비내역</h3>
						<div className="flex-align_center"><strong className="text-blue" style={{ fontSize: "1.8rem" }}>3건</strong><i className="icon icon_arrow_sm right icon_arrow_md ml_5" /></div>
					</div>
				</div>
			</div>

			{/* 사고이력 조회 */}
			<div className="padding">
				<div className="flex-justify_between align_center">
					<div className="flex-align_center">
						<h3>사고이력 조회</h3>
						<span className={`${styles["title-guide"]} ml_10`}>2019.01.01 기준</span>
						<i className="icon icon_update ml_5" />
					</div>
					<i className="icon icon_arrow_sm right icon_arrow_md" />
				</div>
				{/* 데이터 있을 때 */}
				<ul className="list-item mt_40">
					<li>
						<span>내 차 피해</span>
						<span><span className="text-blue">1건</span> (73,789원)</span>
					</li>
					<li>
						<span>상대 차 피해</span>
						<span>0건 (0원)</span>
					</li>
					<li>
						<span>기타이력</span>
						<span className="text-blue">4건</span>
					</li>
				</ul>
				{/* 데이터 없을 때 */}
				<div className="center-cont pt_50 pb_20">
					<i className="icon icon_car_question" />
					<p className="mt_20" style={{ fontSize: "1.8rem", fontWeight: 500 }}>이 차량의 사고이력이 궁금하세요?</p>
					<span className="mt_5" style={{ fontSize: "1.6rem", color: "#666" }}>* 무료조회 횟수 : 2회 / 다음 충전일 <span className="text-red">D-20</span></span>
					<Button className="btn btn--big btn-more mt_30">사고이력 조회하기</Button>
				</div>
				{/* 사고이력 없을 때 */}
				<div className="mt_30" style={{ fontSize: "1.6rem" }}>이 차량은 사고이력이 없어요.</div>
			</div>
		</div>
	)
}

export default CarMy